import { Outlet, useLocation } from 'react-router-dom';

import GlobalStyle from './styles/globalStyles';
import styled, { ThemeProvider as ThemeProviderSC } from 'styled-components'
import { ThemeProvider } from '@mui/material';
import { mono, monoMUI } from './styles/themes';

import Navbar from './components/Navbar/Navbar';
import { navRoutes } from './routes';
import Title from './components/Title';
import breakpoints from './styles/breakpoints';
import Canvas from './components/Canvas';
import { useEffect, useRef, useState } from 'react';

const StyledApp = styled.div<{ $contentTop: number, $scrollBarWidth: number }>`
  position: relative;
  /* mix-blend-mode: multiply;  */
  
  display: flex;
  flex-direction: column;
  gap: 20px;

  height: 100%;
  /* max-width: 1700px; */
 
  box-sizing: border-box;
  padding: 0px;
  /* padding: 30px 60px 20px 60px; */
/* 
  @media ${breakpoints.laptop} {
    padding: 30px 40px 20px 40px;
  }

  @media ${breakpoints.mobile} {
    padding: 20px;
  } */
  
  margin: auto;

  .websiteTitleContainer {
    mix-blend-mode: multiply; 
    box-shadow: 8px 0px 0 ${props => props.theme.alt}, -8px 0px 0 ${props => props.theme.alt};

    /* @media ${breakpoints.mobile} {
      mix-blend-mode: normal;
    } */

    /* background: ${props => props.theme.alt}; */
    /* -webkit-backdrop-filter: blur(5px) opacity(70%); */
    /* backdrop-filter: blur(5px) opacity(70%); */

    transform: translate3d(0, 0, 0);
    will-change: transform;

    /* mask: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, 0) 100%); */
    
    position: sticky;
    top: 30px;
    margin: auto;
    /* left: 50%;
    transform:  translateX(-50%); */
    width: calc(100% - 2 * 60px);
    @media ${breakpoints.laptop} {
      width: calc(100% - 2 * 40px);
    }
    @media ${breakpoints.mobile} {
      /* mix-blend-mode: normal;  */
      width: calc(100% - 2 * 20px);
    }
    max-width: 1500px;
    
    display: flex;
    gap: 20px;
    align-items: center;
    z-index: 1;
  }

  .navbarContainer {
    width: 100%;
  }

  .centerContainer {
    /* background: pink;  */
    height: 100%;
    display: flex;
    justify-content: center;

    padding: 
    ${props => `calc(30px)`} 
    ${props => `calc(60px - ${props.$scrollBarWidth}px)`} 
    30px
    60px;

    @media ${breakpoints.laptop} {
      padding: 
      ${props => `calc(30px)`} 
      ${props => `calc(40px - ${props.$scrollBarWidth}px)`} 
      30px
      40px;
    }

    @media ${breakpoints.mobile} {
      padding: 
      ${props => `calc(30px)`} 
      ${props => `calc(20px - ${props.$scrollBarWidth}px)`} 
      30px
      20px;
    }
  }

  .outletContainer {
    /* background: pink; */
    position: fixed;
    width: calc(100% - 2 * 60px);
    @media ${breakpoints.laptop} {
      width: calc(100% - 2 * 40px);
    }
    @media ${breakpoints.mobile} {
      width: calc(100% - 2 * 20px);
    }
    
    overflow: auto;
    height: 100%;
    margin: auto;

    max-width: 1500px;
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
  }

  .fadeContainer {
    /* position: fixed;
    top: 10%;
    height: 90%;
    margin: auto;
    width: 100%;
    overflow: auto; */
    /* background: pink; */
  }
`

function App() {
  const headerRef = useRef<HTMLDivElement | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const outletContainerRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();
  const [contentTopPadding, setContentTopPadding] = useState<number>(0);
  const [scrollBarWidth, setScrollBarWidth] = useState<number>(0);

  useEffect(() => {
    const resetScrollPosition = () => {
      window.scrollTo(0, 0);

      if (outletContainerRef.current) {
        outletContainerRef.current.scrollTop = 0;
        outletContainerRef.current.scrollLeft = 0;
      }
    };

    const frame = window.requestAnimationFrame(resetScrollPosition);
    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname]);

  useEffect(() => {
    if (!headerRef.current || !contentRef.current) return;

    const headerResizeObserver = new ResizeObserver((size) => {
      let rect = size[0].contentRect;
      // setWidth(rect.width);
      setContentTopPadding(rect.height);
    })
    headerResizeObserver.observe(headerRef.current);
    // console.log("top padding: " + headerRef.current.clientHeight)
    setContentTopPadding(headerRef.current.clientHeight);

    const contentResizeObserver = new ResizeObserver((size) => {
      let scrollWidth = (size[0].target as HTMLDivElement).offsetWidth - (size[0].target as HTMLDivElement).clientWidth;
      setScrollBarWidth(scrollWidth);
    })
    contentResizeObserver.observe(contentRef.current);
    setScrollBarWidth(contentRef.current.offsetWidth - contentRef.current.clientWidth);
  }, [])

  return (
    <ThemeProvider theme={monoMUI}>
      <ThemeProviderSC theme={mono}>
        <Canvas>
          <StyledApp $contentTop={contentTopPadding} $scrollBarWidth={scrollBarWidth}>
            <GlobalStyle />
            <div className={"websiteTitleContainer"} ref={headerRef}>
              <Title />
              <div className={"navbarContainer"}>
                <Navbar links={navRoutes.map(route => (route.path))} />
              </div>
            </div>
            {/* <div className="fadeContainer"> */}
            <div className={"centerContainer"} ref={contentRef}>
              <div className="outletContainer" ref={outletContainerRef}>
                <Outlet />
              </div>
            </div>
            {/* </div> */}
          </StyledApp>
        </Canvas>
      </ThemeProviderSC >
    </ThemeProvider>
  );
}

export default App;
